import { RiInformationLine } from 'react-icons/ri';
import { UncontrolledTooltip } from 'reactstrap';

import ChipIcon from './ChipIcon';
import StatusPill from './StatusPill';

const IndustryPeerComparison = ({
    t,
    comparisons,
}) => (
    <>
        <div className="d-flex align-items-center gap-2 mb-2">
            <h6 className="overview-esg-rating__table-title mb-0">
                {t('Industry & Peer Comparison')}
            </h6>
            <ChipIcon />
        </div>

        <div className="table-responsive overview-esg-rating__table-wrapper">
            <table className="table overview-esg-rating__table mb-0">
                <thead>
                    <tr>
                        <th>{t('Provider')}</th>
                        <th>{t('HUGO BOSS')}</th>
                        <th>{t('Industry Avg')}</th>
                        <th>{t('Industry Standing')}</th>
                        <th>{t('Peers')}</th>
                    </tr>
                </thead>
                <tbody>
                    {(comparisons || []).map((row) => {
                        const hintId = `esg-peer-hint-${row.key}`;

                        return (
                            <tr key={row.key}>
                                <td>
                                    <span className="overview-esg-rating__provider">
                                        {row.provider}

                                        {row.hint && (
                                            <>
                                                <span
                                                    id={hintId}
                                                    className="overview-esg-rating__info"
                                                >
                                                    <RiInformationLine size={14} />
                                                </span>

                                                <UncontrolledTooltip
                                                    target={hintId}
                                                    placement="top"
                                                    innerClassName="overview-esg-rating__tooltip"
                                                >
                                                    {t(row.hint)}
                                                </UncontrolledTooltip>
                                            </>
                                        )}
                                    </span>
                                </td>
                                <td>
                                    <span className="overview-esg-rating__rating-link">
                                        {row.hugoBoss}
                                    </span>
                                </td>
                                <td className="overview-esg-rating__muted">
                                    {row.industryAvg}
                                </td>
                                <td>
                                    <StatusPill
                                        label={t(row.standing)}
                                        color={row.standingColor}
                                    />
                                </td>
                                <td className="overview-esg-rating__peers">
                                    {row.peers}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    </>
);

export default IndustryPeerComparison;
